import { AxiosPost } from "./AxiosCall";

export const LoginAdminApi = async ({user,pass})=>{
    try {
      let res = await AxiosPost("login", {
        email: user,
        password:pass
      });
      return res;
    } catch (error) {
      return error;
    }
  }